"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMinimalFS = void 0;
var tslib_1 = require("tslib");
var path_1 = require("path");
function createMinimalFS(_a) {
    var files = _a.files /*, trimWS*/;
    var creationDate = new Date();
    var filesMap = new Map(Object.entries(files).map(function (_a) {
        var _b = tslib_1.__read(_a, 2), filePath = _b[0], _c = _b[1], content = _c.content, _d = _c.mtime, mtime = _d === void 0 ? creationDate : _d;
        return [filePath, { content: content, mtime: mtime }];
    }));
    var directoryPaths;
    var setDirectoryPaths = function () {
        var e_1, _a, e_2, _b;
        directoryPaths = new Set();
        try {
            for (var _c = tslib_1.__values(filesMap.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var filePath = _d.value;
                try {
                    for (var _e = (e_2 = void 0, tslib_1.__values(getParentPaths((0, path_1.dirname)(filePath)))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var directoryPath = _f.value;
                        directoryPaths.add(directoryPath);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    setDirectoryPaths();
    var fs = {
        readFileSync: function (path) {
            if (!files[path]) {
                throw new Error('Cannot find file: ' + path);
            }
            // if (trimWS) {
            //     return deindent(files[path].content).trim();
            // }
            return files[path].content;
        },
        statSync: function (path) {
            var isDirectory = directoryPaths.has(path);
            var fileEntry = filesMap.get(path);
            if (!fileEntry && !isDirectory) {
                throw new Error("ENOENT: no such file or directory, stat ".concat(path));
            }
            return {
                isDirectory: function () {
                    return isDirectory;
                },
                isFile: function () {
                    return !!fileEntry;
                },
                mtime: fileEntry ? fileEntry.mtime : new Date(),
            };
        },
        readlinkSync: function () {
            throw new Error("not implemented");
        },
        writeFileSync: function (path, content) {
            var fileEntry = filesMap.get(path);
            if (fileEntry) {
                files[path].content = content;
                var mtime = (files[path].mtime = new Date(++files[path].v));
                filesMap.set(path, { content: content, mtime: mtime });
            }
            else {
                var v = 1;
                var mtime = new Date(v);
                files[path] = { content: content, mtime: mtime, v: v };
                filesMap.set(path, { content: content, mtime: mtime });
                setDirectoryPaths();
            }
        },
        removeFileSync: function (path) {
            delete files[path];
            filesMap.delete(path);
            setDirectoryPaths();
        },
    };
    var requireModule = function require(id) {
        var _module = {
            id: id,
            exports: {},
        };
        try {
            if (!id.match(/\.js$/)) {
                id += '.js';
            }
            // eslint-disable-next-line @typescript-eslint/no-implied-eval
            var fn = new Function('module', 'exports', 'require', files[id].content);
            fn(_module, _module.exports, requireModule);
        }
        catch (e) {
            throw new Error('Cannot require file: ' + id);
        }
        return _module.exports;
    };
    function resolvePath(_ctx, path) {
        return path;
    }
    return {
        fs: fs,
        requireModule: requireModule,
        resolvePath: resolvePath,
    };
}
exports.createMinimalFS = createMinimalFS;
function getParentPaths(initialDirectoryPath) {
    var parentPaths = [];
    var currentPath = initialDirectoryPath;
    var lastPath;
    while (currentPath !== lastPath) {
        parentPaths.push(currentPath);
        lastPath = currentPath;
        currentPath = (0, path_1.dirname)(currentPath);
    }
    return parentPaths;
}
//# sourceMappingURL=memory-minimal-fs.js.map